var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheapest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cheapest-e {\r\n        fill: #45484a;\r\n      }\r\n\r\n      .cheapest-f, .cheapest-g {\r\n        fill: none;\r\n      }\r\n\r\n      .cheapest-g {\r\n        stroke: #45484a;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cheapest-f",
    width: 28,
    height: 28
  })), /*#__PURE__*/React.createElement("path", {
    className: "cheapest-g",
    d: "M6.13,14.49h14.37c.82,0,1.49.67,1.49,1.49v6.42c0,.82-.67,1.49-1.49,1.49H7.62c-.82,0-1.49-.67-1.49-1.49v-7.91h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cheapest-g",
    x1: 7.23,
    y1: 14.49,
    x2: 20.89,
    y2: 14.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cheapest-g",
    cx: 18.79,
    cy: 19.25,
    r: 0.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cheapest-g",
    points: "9.67 13.75 8.21 11.16 18.72 5.19 21.83 10.67 16.38 13.76"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cheapest-f",
    d: "M15.2,12.06c.36-.21.03-.88-.13-1.16-.19-.34-.57-.88-.91-.68-.24.14-.19.59.13,1.16.31.55.67.82.91.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cheapest-f",
    d: "M16.45,8.91c-.24.14-.19.59.13,1.16.31.55.67.82.91.68.36-.21.03-.88-.13-1.16-.19-.34-.57-.88-.91-.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cheapest-e",
    points: "12.27 11.51 13.47 13.62 14.02 13.31 12.47 10.58 12.04 10.83 11.59 11.54 11.99 11.95 12.27 11.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cheapest-e",
    d: "M15.45,12.55c.62-.35.69-1.08.17-1.99-.49-.86-1.13-1.18-1.72-.85-.6.34-.67,1.11-.18,1.97.5.86,1.16,1.19,1.73.86ZM14.16,10.21c.35-.2.72.34.91.68.16.28.49.95.13,1.16-.24.14-.6-.13-.91-.68-.32-.57-.37-1.02-.13-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cheapest-e",
    d: "M17.91,9.26c-.49-.86-1.13-1.18-1.72-.85-.6.34-.67,1.11-.18,1.97.5.86,1.16,1.19,1.73.86.62-.35.69-1.08.17-1.99ZM17.49,10.76c-.24.14-.6-.13-.91-.68-.32-.57-.37-1.02-.13-1.16.35-.2.72.34.91.68.16.28.49.95.13,1.16Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheapest);
export default __webpack_public_path__ + "static/media/cheapest.32fe84e8cb29c888ea2ea6d7e5eb66c9.svg";
export { ForwardRef as ReactComponent };